import greenFolder from "../img/green.png";
import greyFolder from "../img/grey.png";
import gardrobePreview from "../img/gardrobe-preview.png";

export function Gallery() {
  const projects = [
    {
      title: "Gardrobe",
      image: gardrobePreview,
      alt: "Gardrobe e-commerce demo cover",
      demo: "https://gardrobe.vercel.app/",
      source: "https://github.com/vbarcellos/gardrobe",
      summary:
        "React 18 + Redux Toolkit store, fake API, cart & categories.",
      tags: ["React 18", "Redux Toolkit", "Router", "Axios"],
    },
    { title: "Project 02", image: greenFolder, alt: "Project 02" },
    { title: "Project 03", image: greyFolder, alt: "Project 03" },
  ];

  return (
    <section className="gallery container py-5">
      <header className="text-center mb-4">
        <h2 className="fw-bold mb-2">Projects Gallery</h2>
        <p className="text-muted m-0">Selected work — live demos and source code.</p>
      </header>

      <div className="row g-4">
        {projects.map((p, idx) => (
          <div key={p.title + idx} className="col-12 col-md-6 col-lg-4">
            <article className="card h-100 border-0 shadow-sm gallery-card">
              <div className="ratio ratio-4x3 overflow-hidden">
                <img
                  className="card-img-top object-fit-cover gallery-thumb folder"
                  src={p.image}
                  alt={p.alt || p.title}
                  loading="lazy"
                />
              </div>

              <div className="card-body d-flex flex-column">
                <h3 className="h5 card-title mb-2">{p.title}</h3>

                {p.summary && (
                  <p className="card-text text-muted small mb-3">{p.summary}</p>
                )}

                {Array.isArray(p.tags) && p.tags.length > 0 && (
                  <ul className="list-inline small mb-3">
                    {p.tags.map((t) => (
                      <li key={t} className="list-inline-item tag-badge">
                        {t}
                      </li>
                    ))}
                  </ul>
                )}

                <div className="mt-auto d-flex gap-2 flex-wrap">
                  {p.demo && (
                    <a
                      className="btn btn-primary btn-sm"
                      href={p.demo}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Open live demo of ${p.title}`}
                    >
                      Live Demo
                    </a>
                  )}
                  {p.source && (
                    <a
                      className="btn btn-outline-secondary btn-sm"
                      href={p.source}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Open GitHub source of ${p.title}`}
                    >
                      Source
                    </a>
                  )}
                </div>
              </div>
            </article>
          </div>
        ))}
      </div>
    </section>
  );
}
